// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1Ew2b","footer":"ModalUpdate_footer__3m5o0"};